import { useQuery } from "react-query";
import { ImplementationGuideApi } from "../generate/apis";
import { call } from "./api";

interface Options {
  refetchOnMount?: boolean | "always";
}

// A failed lookup resolves to null so it reads as "no guide" rather than an error.
export const useImplementationGuide = (client: string, options: Options = {}) => {
  const fetch = async (): Promise<string | null> => {
    try {
      const { data } = await call(ImplementationGuideApi).implementationGuideGet({ client });
      return data ?? null;
    } catch {
      return null;
    }
  };

  return useQuery<string | null>(["implementation-guide", client], fetch, {
    retry: false,
    enabled: Boolean(client),
    refetchOnMount: options.refetchOnMount,
  });
};
